import { StepperContext, useStepperContext } from '../../../components/Stepper/Context';
import { useStepper } from '../../../components/Stepper/Hooks';

type StepId = string;

type StepType = {
  id: StepId;
  order: number;
};

type StepperProps = React.PropsWithChildren<{
  steps: StepType[];
  initialStep: StepId;
}>;

export function StepperProvider(props: StepperProps) {
  const value = useStepper(props);

  if (!props.initialStep || props.steps.length === 0) {
    return <div>Error: No steps defined.</div>; // Renderiza um erro caso não haja steps
  }

  return <StepperContext.Provider value={value}>{props.children}</StepperContext.Provider>;
}

type StepProps = {
  step: StepId;
  component: React.ComponentType<any>;
};

export function StepperContainer(props: StepProps) {
  const stepperContext = useStepperContext();
  return stepperContext.isCurrentStep(props.step) ? (
    <div className="min-h-full">
      <props.component />
    </div>
  ) : null;
}
